"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_ROLLBACK_ERROR_PREFIX = void 0;
// @see https://www.postgresql.org/docs/current/errcodes-appendix.html
exports.TRANSACTION_ROLLBACK_ERROR_PREFIX = '40';
